import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import doc_processing_icon from "../../../images/doc_processing_icon.png";
import Header from "../../Includes/Header";
import Footer from "../../Includes/Footer";
import { useNavigate } from "react-router-dom";

function VerificationFail() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Container fluid className="min-vh-custom">
        <br /><br /><br /><br />
        <Row className="mt-5">
          <Col md={12} className="text-center">
            <img src={doc_processing_icon} width={60} alt="doc icon" />
            <h3 className="text-center mt-3">{t('register.verification_failed_title')}</h3>
            <p className="text-secondary mt-3">{t('register.verification_failed_desc')}</p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-center">
            <Button className="btn btn-primary mt-3 rounded-5" onClick={() => navigate("/")}>
              {t('common.retake')}
            </Button>
          </Col>
          <Col md={12} className="text-center py-3">
            <span className="text-secondary">
              {t('register.need_help')}{" "}
              <Link className="text-primary" to={""}>
                {t('common.customer_support')}
              </Link>
            </span>
          </Col>
        </Row>
      </Container>
      <Footer full={true} />
    </>
  );
}

export default VerificationFail;
